import { BrowserRouter, StaticRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

export type AppProps = {
  /** ビルド時プリレンダ専用：指定時は StaticRouter で描画 */
  ssrPathname?: string;
};

export default function App({ ssrPathname }: AppProps) {
  const basename = __BASE_PATH__;
  const router =
    ssrPathname !== undefined ? (
      <StaticRouter basename={basename} location={ssrPathname}>
        <AppRoutes />
      </StaticRouter>
    ) : (
      <BrowserRouter basename={basename}>
        <AppRoutes />
      </BrowserRouter>
    );

  return <I18nextProvider i18n={i18n}>{router}</I18nextProvider>;
}
